import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircle } from 'lucide-react';
import { trackMetaEvent } from './MetaPixel';
export function WhatsAppButton() {
  return <motion.a href="https://wa.link/ip1ujo" target="_blank" rel="noopener noreferrer" initial={{
    scale: 0,
    opacity: 0
  }} animate={{
    scale: 1,
    opacity: 1
  }} transition={{
    delay: 1,
    type: 'spring',
    stiffness: 260,
    damping: 20
  }} whileHover={{
    scale: 1.05
  }} whileTap={{
    scale: 0.95
  }} onClick={() => trackMetaEvent('Contact', {
    content_name: 'Soporte WhatsApp'
  })} className="fixed bottom-4 right-4 sm:bottom-6 sm:right-6 z-40 bg-green-500 hover:bg-green-600 text-white p-3 sm:px-6 sm:py-4 rounded-full shadow-xl sm:shadow-2xl flex items-center gap-3 font-bold transition-colors group" data-id="element-265">
      <MessageCircle className="w-5 h-5 sm:w-6 sm:h-6 group-hover:rotate-12 transition-transform" data-id="element-266" />
      <span className="hidden sm:inline" data-id="element-267">Soporte WhatsApp</span>
    </motion.a>;
}